import API from "../../../app/api";

export const getMenuService = async () => {
  try {
    const res = await API.get("/megamenu");
    if (res.data?.success) {
      return res.data.data || [];
    }
    return [];
  } catch (error) {
    console.error("Mega Menu Error:", error);
    return [];
  }
};